import { translateFunc } from "client/utils/translateFunc";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { SearchIcon } from "components/common/Icons/SearchIcon";
import { ChangeEvent } from "react";

interface SearchProps {
    search: string;
    handleSearch: (e: ChangeEvent<HTMLInputElement>) => void;
    handleSearchCrossButtonClick: () => void;
}

export const Search = ({ search, handleSearch, handleSearchCrossButtonClick }: SearchProps) => {
    return (
        <div className="flex items-center bg-irGray-200 dark:bg-darkSurface-300 gap-2 px-2 rounded-lg">
            <div>
                <SearchIcon />
            </div>
            <div className="w-full">
                <input
                    value={search}
                    onChange={handleSearch}
                    placeholder={translateFunc("search-icons")}
                    className="outline-none w-full py-2.5 bg-transparent"
                />
            </div>
            {search.length > 0 && (
                <button
                    className="bg-irGray-500 dark:bg-darkSurface-200 hover:bg-irGray-600 dark:hover:bg-darkSurface-100 rounded-full w-[14px] h-[14px] flex items-center justify-center flex-shrink-0"
                    onClick={handleSearchCrossButtonClick}
                >
                    <CloseIcon stroke={"white"} width={8} height={8} />
                </button>
            )}
        </div>
    );
};
